import { ThemeMode } from '../constants/themeConstants';
import { useTheme } from '../context/ThemeContext';
import healthesusLogomarkColor from '../assets/HS-Logomark-color.svg';
import healthesusLogomarkWhite from '../assets/HS-Logomark-white.svg';

/**
 * Resolved Healthesus tertiary logomark asset for the current theme.
 * Light: full-color SVG; dark: white mark for charcoal canvases (brand clear space unchanged — see `--brand-logomark-*` in `portal-theme-light.css`).
 */
export function useHealthesusLogomarkSrc(): string {
  const { theme } = useTheme();
  return theme === ThemeMode.DARK ? healthesusLogomarkWhite : healthesusLogomarkColor;
}
